module.exports = __webpack_public_path__ + "static/media/back.303333fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/cards/back.png
// module id = 261
// module chunks = 0